"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addStyleVariantClasses = exports.getStyleVariantClasses = exports.StyleVariant = void 0;
var StyleVariant;
(function (StyleVariant) {
    StyleVariant["primary"] = "primary";
    StyleVariant["quaternary"] = "quaternary";
    StyleVariant["positive"] = "positive";
})(StyleVariant = exports.StyleVariant || (exports.StyleVariant = {}));
function getStyleVariantClasses(styleVariant) {
    switch (styleVariant) {
        case 'primary':
            return ['btn-cta'];
        case 'quaternary':
            return ['btn-orange'];
        case 'positive':
            return ['btn-positive'];
        default:
            return [];
    }
}
exports.getStyleVariantClasses = getStyleVariantClasses;
function addStyleVariantClasses(element, styleVariant, removeStyleDisplay) {
    if (removeStyleDisplay === void 0) { removeStyleDisplay = false; }
    getStyleVariantClasses(styleVariant)
        .map(function (styleClass) {
        var initialStyleTransition = element.style.transition;
        element.style.transition = 'none';
        if (!element.classList.contains(styleClass)) {
            element.classList.add(styleClass);
        }
        setTimeout(function () {
            element.style.transition = initialStyleTransition;
            if (removeStyleDisplay && element.style.display === 'none') {
                element.style.removeProperty('display');
            }
        }, 0);
    });
}
exports.addStyleVariantClasses = addStyleVariantClasses;
